import React from "react";
import { Facet } from "@linkfluence/models/facet";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { Card } from "@radarly/models/cards";
import { Clause } from "@radarly/models/clause";
import { refineClauseWithoutField } from "@radarly/models/clause/refiner";
import { useIsCurrentInsightPageGlobal } from "@radarly/models/insight-pages/is";
import FilterBar, { IProps as FilterBarProps } from "@radarly/shared/filterbar";

type SharedPanelsCardEditionHeaderProps = Pick<
  FilterBarProps,
  | "applyClause"
  | "onApply"
  | "setClause"
  | "onClose"
  | "setPeriod"
  | "hasClause"
  | "timezone"
  | "period"
> & {
  clause: Clause;
  card: Card;
  onPasteFilters: (clause: Clause) => void;
  errorMsg?: string;
  isVisibleAndDisabled?: boolean;
  disabledTooltipLabel?: string;
};

export default function SharedPanelsCardEditionHeader({
  clause,
  card,
  period,
  onPasteFilters,
  errorMsg = "",
  isVisibleAndDisabled,
  disabledTooltipLabel,
  ...props
}: SharedPanelsCardEditionHeaderProps) {
  const clauseWithoutDateAndWorkspace = refineClauseWithoutField(
    refineClauseWithoutField(clause, "date"),
    "dashboard"
  );
  const locale = useCurrentUserLocale();
  const globalPageContext = useIsCurrentInsightPageGlobal();
  return (
    <FilterBar
      onPasteFilters={onPasteFilters}
      card={card}
      allowCopyPaste
      sticky={false}
      period={period}
      fields={[Facet.Focuses]}
      clause={clauseWithoutDateAndWorkspace}
      hideFreeFilters={false}
      permanentLabels={{
        [Facet.Focuses]: tr(
          locale,
          `CUSTOM_PAGES::EDITOR::FILTER_BAR::${
            globalPageContext ? "ALL_PROJECT_QUERIES" : "ALL_QUERIES"
          }`
        ),
      }}
      isPeriodSelectorEnabled
      allowBeyondLimit
      isVisibleAndDisabled={isVisibleAndDisabled}
      disabledTooltipLabel={disabledTooltipLabel}
      {...props}
    />
  );
}
